"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var Terms = _interopRequireWildcard(require("self-service-api/constants/Terms"));

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _PriceBreakdownModal = _interopRequireDefault(require("pricing-pages-unified-ui/components/calculator/PriceBreakdownModal"));

var _CalculatorCTAsContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/calculator/CalculatorCTAsContainer"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _CalculatorPriceDisplayTile = _interopRequireDefault(require("./CalculatorPriceDisplayTile"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _MerchandiseSelectors = require("../../selectors/MerchandiseSelectors");

var _ActiveHubSelectors = require("pricing-pages-unified-ui/selectors/ActiveHubSelectors");

var _RequiredOnboardingSelectors = require("../../selectors/RequiredOnboardingSelectors");

var _HubCalcRequiredOnboardingSectionContainer = _interopRequireDefault(require("./HubCalcRequiredOnboardingSectionContainer"));

var _PricingSelectors = require("../../selectors/PricingSelectors");

var _stateUtils = require("../../utils/stateUtils");

var _ItemConfigsSelectors = require("../../selectors/ItemConfigsSelectors");

var _itemConfigUtils = require("../../utils/itemConfigUtils");

var _Calculator = require("pricing-pages-unified-ui/components/calculator/Calculator");

var _this = void 0;

var HubCalcPriceDisplayTileContainer = function HubCalcPriceDisplayTileContainer(_ref) {
  var _bundleSelections, _bundleSelections2;

  var activeCurrencyCode = _ref.activeCurrencyCode,
      activeHub = _ref.activeHub,
      getRequiredOnboardingMerchId = _ref.getRequiredOnboardingMerchId,
      getMerchIdForEdition = _ref.getMerchIdForEdition;

  var _useContext = (0, _react.useContext)(_Calculator.CalculatorContext),
      state = _useContext.state;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isModalVisible = _useState2[0],
      setModalVisibility = _useState2[1];

  var unitsKey = _stateUtils.HubToAdditionalUnitsParamKey[activeHub];
  var activeEdition = state.edition,
      selectedAddOns = state.addons,
      selectedServices = state.services,
      additionalUnitQuantity = state[unitsKey];

  var _useActiveTerm = (0, _stateUtils.useActiveTerm)(),
      activeTerm = _useActiveTerm.activeTerm;

  var activeMerchId = getMerchIdForEdition(activeHub, activeEdition);
  var calculateBundlePrice = (0, _reactRedux.useSelector)(_PricingSelectors.getCalculateBundlePriceSelector);
  var getAvailableTermsForMerch = (0, _reactRedux.useSelector)(_ItemConfigsSelectors.getAvailableTermsForMerchSelector);
  var availableTerms = getAvailableTermsForMerch(activeMerchId);
  activeTerm = (0, _itemConfigUtils.getApplicableTerm)(activeTerm, availableTerms);
  var activeHubMerchKey = activeHub + "PlanSelected";
  var activeHubUnitsKey = activeHub + "Units";
  var pricingInfo = calculateBundlePrice({
    bundleSelections: (_bundleSelections = {}, (0, _defineProperty2.default)(_bundleSelections, activeHubMerchKey, activeMerchId), (0, _defineProperty2.default)(_bundleSelections, activeHubUnitsKey, additionalUnitQuantity), (0, _defineProperty2.default)(_bundleSelections, "selectedAddOns", selectedAddOns), (0, _defineProperty2.default)(_bundleSelections, "selectedServices", selectedServices), _bundleSelections),
    term: activeTerm
  });
  var getMultiplePriceBreakdowns = (0, _reactRedux.useSelector)(_PricingSelectors.getMultiplePriceBreakdownsSelector);
  var allPriceBreakdowns = getMultiplePriceBreakdowns({
    bundleSelections: (_bundleSelections2 = {}, (0, _defineProperty2.default)(_bundleSelections2, activeHubMerchKey, activeMerchId), (0, _defineProperty2.default)(_bundleSelections2, activeHubUnitsKey, additionalUnitQuantity), (0, _defineProperty2.default)(_bundleSelections2, "selectedAddOns", selectedAddOns), (0, _defineProperty2.default)(_bundleSelections2, "selectedServices", selectedServices), (0, _defineProperty2.default)(_bundleSelections2, "term", activeTerm), _bundleSelections2)
  });
  var recurringMerchPriceBreakdown = allPriceBreakdowns.filter(function (breakdown) {
    return breakdown.monthly.calculatedPrice !== 0;
  }).map(function (breakdown) {
    return {
      monthly: breakdown.monthly,
      annually: breakdown.annually
    };
  });
  var oneTimeMerchPriceBreakdown = allPriceBreakdowns.filter(function (breakdown) {
    return breakdown.oneTimeFee.calculatedPrice !== 0;
  }).map(function (breakdown) {
    return breakdown.oneTimeFee;
  });

  var togglePriceBreakdown = function togglePriceBreakdown(isVisible) {
    setModalVisibility(isVisible);

    if (isVisible) {
      (0, _getUsageTracker.default)().track('clickToViewModal', {
        name: 'price-breakdown-modal'
      });
    }
  };

  var getCostToGetStarted = function getCostToGetStarted() {
    var oneTimeFee = pricingInfo.oneTimeFee.calculatedPrice;

    if (activeTerm === Terms.MONTHLY) {
      return pricingInfo.monthly.calculatedPrice + oneTimeFee;
    }

    if (activeTerm === Terms.ANNUAL) {
      return pricingInfo.annually.calculatedPrice + oneTimeFee;
    }

    return null;
  };

  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_CalculatorPriceDisplayTile.default, {
    gaTrackingId: activeHub,
    activeTerm: activeTerm,
    monthlyCost: pricingInfo.monthly.calculatedPrice,
    costToGetStarted: getCostToGetStarted(),
    activeCurrencyCode: activeCurrencyCode,
    onViewPriceBreakdownClick: (0, _partial.default)(togglePriceBreakdown, true),
    ctasComponent: _react.default.createElement(_CalculatorCTAsContainer.default, {
      activeTerm: activeTerm,
      merchandiseId: activeMerchId,
      additionalUnitQuantity: additionalUnitQuantity
    }),
    showTotalPriceAsterisk: !!getRequiredOnboardingMerchId(activeMerchId),
    requiredOnboardingSubtext: _react.default.createElement(_HubCalcRequiredOnboardingSectionContainer.default, {
      term: activeTerm,
      merchandiseId: activeMerchId
    })
  }), isModalVisible && _react.default.createElement(_PriceBreakdownModal.default, {
    onCloseClick: (0, _partial.default)(togglePriceBreakdown, false),
    estimatedCostToGetStarted: getCostToGetStarted(),
    activeTerm: activeTerm,
    activeMerchId: activeMerchId,
    pricingInfo: pricingInfo,
    recurringMerchPriceBreakdown: recurringMerchPriceBreakdown,
    oneTimeMerchPriceBreakdown: oneTimeMerchPriceBreakdown
  }));
};

HubCalcPriceDisplayTileContainer.propTypes = {
  activeCurrencyCode: _propTypes.default.string.isRequired,
  activeHub: _propTypes.default.oneOf(Object.values(_Hubs.default || {})),
  getRequiredOnboardingMerchId: _propTypes.default.func.isRequired,
  getMerchIdForEdition: _propTypes.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    activeHub: (0, _ActiveHubSelectors.activeHubSelector)(state),
    getRequiredOnboardingMerchId: _RequiredOnboardingSelectors.requiredOnboardingMerchIdSelector.bind(_this, state),
    getMerchIdForEdition: (0, _MerchandiseSelectors.getMerchIdForEditionSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(HubCalcPriceDisplayTileContainer);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/HubCalcPriceDisplayTileContainer.js
// module id = 342
// module chunks = 5 6